import { useEffect, useState } from "react";
import { aboutContent } from "../data/siteContent";
import { FaArrowTrendUp, FaCompassDrafting, FaLayerGroup } from "react-icons/fa6";
import { callApi } from "../Helpers";

export default function AboutUsContent() {
  const icons = [<FaCompassDrafting />, <FaLayerGroup />, <FaArrowTrendUp />];
  const [faqs, setFaqs] = useState([]);

  async function getAllFaqs() {
    await callApi("get-all-faqs", {}).then((response) => {
      if (response.status === 1) {
        setFaqs(Array.isArray(response.data) ? response.data : []);
      } else {
        setFaqs([]);
      }
    });
  }

  useEffect(() => {
    getAllFaqs();
  }, []);

  return (
    <section className="ags-section ags-about-main-section">
      <div className="container">
        <div className="row g-4 align-items-stretch mb-5">
          <div className="col-lg-7" data-aos="fade-right">
            <div className="ags-surface-panel h-100" >
              <p className="ags-section-kicker mb-3">{aboutContent.historyTitle}</p>
              <h2 className="main-section-title mb-3">AGS Establishment and Journey</h2>
              <p className="text-muted mNoMargin">{aboutContent.p1}</p>
              <p className="text-muted  mt-3">{aboutContent.p2}</p>
              <p className="text-muted  mt-3">{aboutContent.p3}</p>
              <p className="text-muted  mt-3">{aboutContent.p4}</p>
            </div>
          </div>
          <div className="col-lg-5" data-aos="fade-left">
            <div className="ags-dark-panel h-100">
              <div className="ags-about-photo-card mb-4">
                <img
                  src={aboutContent.image}
                  alt="Africa Geospatial Solutions"
                  className="ags-about-photo-image"
                />
              </div>
              <p className="ags-section-kicker text-secondary mb-3">Mission</p>
              <p className="text-white-50 mb-4">{aboutContent.mission}</p>
              <p className="ags-section-kicker text-secondary mb-3">Vision</p>
              <p className="text-white-50 mNoMargin">{aboutContent.vision}</p>
            </div>
          </div>
        </div>

        <div className="row g-4 mb-5">
          {aboutContent.values.map((value, index) => (
            <div
              className="col-md-4"
              key={value.title}
              data-aos="fade-up"
              data-aos-delay={index * 50}
            >
              <div className="ags-value-card h-100 p-4">
                <div className="ags-value-icon mb-3">{icons[index]}</div>
                <h5 className="font-bold mb-2">{value.title}</h5>
                <p className="text-muted mNoMargin">{value.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="container" data-aos="fade-up">
          <div className="ags-faq-heading-wrap mb-4">
              <h2 className="ags-faq-title mb-3">FAQs</h2>
              <p className="ags-faq-subtitle mb-0">
                Unparalleled Insights Through Advanced Imaging Technologies
              </p>
          </div>

          <div className="accordion ags-faq-accordion" id="agsFaqAccordion">
            {faqs.map((faq, index) => (
              <div className="accordion-item" key={faq.uuid || faq.question}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#ags-faq-${index}`}
                    aria-expanded={index === 0 ? "true" : "false"}
                    aria-controls={`ags-faq-${index}`}
                  >
                    {faq.question}
                  </button>
                </h2>
                <div
                  id={`ags-faq-${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                  data-bs-parent="#agsFaqAccordion"
                >
                  <div className="accordion-body">{faq.answer}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
